import { MapPin, Eye, Award, Users } from "lucide-react";

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="pt-24 pb-16 min-h-screen">
      {/* Hero */}
      <section className="px-6 lg:px-8 max-w-7xl mx-auto mb-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="font-cursive text-gold text-4xl mb-4">About Us</p>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-none text-beige mb-6">
              Crafting Dreams in South Goa
            </h1>
            <p className="text-beige/70 leading-relaxed mb-6">
              Noor Realtor is South Goa's premier luxury real estate consultancy.
              We specialize in curating exceptional properties — from oceanfront villas
              and designer apartments to prime development land — for discerning buyers
              who seek more than just a home.
            </p>
            <p className="text-beige/60 leading-relaxed">
              With deep local knowledge and an unwavering commitment to quality,
              we connect our clients with properties that embody the serene beauty
              and vibrant spirit of Goa. Our approach is personal, our standards are
              uncompromising, and our goal is simple: to find you the perfect space
              to call your own.
            </p>
          </div>

          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden rounded-sm">
              <img
                src="https://static.prod-images.emergentagent.com/jobs/f994a921-acd5-4ef7-a754-2485a6eee63b/images/5c8e38e0e2b5188eb64fc8c38a8d0d135866384487d9fbc1470a643db79bc80f.png"
                alt="Luxury villa in South Goa"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-gold text-navy p-6 rounded-sm">
              <p className="font-heading text-3xl font-bold">10+</p>
              <p className="text-sm font-bold tracking-wider uppercase">Years Experience</p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 px-6 lg:px-8 bg-navy-light">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-xs tracking-[0.2em] uppercase text-gold font-bold mb-3">Our Values</p>
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight text-beige">
              Why Choose Noor Realtor
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: Eye,
                title: "Curated Selection",
                desc: "Every property is handpicked and vetted to meet our exacting standards of quality and value.",
              },
              {
                icon: MapPin,
                title: "Local Expertise",
                desc: "Deep roots in South Goa with insider knowledge of every neighborhood, beach, and hidden gem.",
              },
              {
                icon: Award,
                title: "Trusted Reputation",
                desc: "A decade of successful transactions and satisfied clients who return and refer with confidence.",
              },
              {
                icon: Users,
                title: "Personal Approach",
                desc: "Dedicated consultants who understand your vision and work tirelessly to make it reality.",
              },
            ].map((value, i) => (
              <div
                key={i}
                className="p-6 border border-white/10 rounded-sm"
              >
                <value.icon size={24} className="text-gold mb-4" />
                <h3 className="font-heading text-lg text-beige mb-2">{value.title}</h3>
                <p className="text-sm text-beige/60 leading-relaxed">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Locations */}
      <section className="py-20 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <p className="text-xs tracking-[0.2em] uppercase text-gold font-bold mb-3">Coverage Area</p>
            <h2 className="font-heading text-2xl sm:text-3xl tracking-tight text-beige">
              South Goa Locations We Serve
            </h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {["Benaulim", "Colva", "Varca", "Palolem", "Majorda", "Canacona"].map((loc) => (
              <div
                key={loc}
                className="p-4 border border-white/10 rounded-sm text-center hover:border-gold/30 transition-colors"
              >
                <MapPin size={16} className="text-gold mx-auto mb-2" />
                <p className="text-sm text-beige font-heading">{loc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
